import { connect } from 'react-redux';
import Avatar from '../../components/avatar';
import { getCurrentUser } from '../../selectors/current-user-selectors';

const mapStateToProps = state => ({
  user: getCurrentUser(state),
});

export default connect(mapStateToProps)(Avatar);



// WEBPACK FOOTER //
// ./app/containers/current-user-avatar/current-user-avatar.js